import { initTsrReactQuery } from "@ts-rest/react-query/v5"
import { tsRestFetchApi, type ClientInferRequest } from "@ts-rest/core"
import { auth } from "./firebase"
import { contractRouter } from "../../../api/src/ts-rest-contract"
import { usePermStore } from "./perm-store"

export type ClientInput<T extends keyof typeof contractRouter> =
  ClientInferRequest<(typeof contractRouter)[T]>

export const client = initTsrReactQuery(contractRouter, {
  baseUrl: import.meta.env.VITE_API_BASE_URL,
  baseHeaders: {
    authorization: `Bearer`,
  },
  api: async (args) => {
    const token = await auth.currentUser?.getIdToken()
    const headers: Record<string, string> = {
      authorization: `Bearer ${token}`,
      "content-type": "application/json",
    }

    const { emulateUserId } = usePermStore.getState()
    if (emulateUserId) {
      headers["emulate-user-id"] = emulateUserId
    }

    return tsRestFetchApi({
      ...args,
      headers,
    })
  },
})

export function validateClientProperty(property: keyof typeof client) {
  return property
}
